// Basemap CARTO (Positron). A chave e publica e fica no bundle do front:
// e assim que o CARTO distribui basemaps. Solicitada em carto.com/basemaps/apikey
// Limite de uso gratuito: 5 milhoes de tiles/mes.
export const CARTO_BASEMAP_KEY = "cb1_3hp7_1_f135395dcdd74ee0ca7daa3f";

export const MAP_TILE_URL = `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=${CARTO_BASEMAP_KEY}`;

// Atribuicao obrigatoria: e a contrapartida do tier gratuito do CARTO.
export const MAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';
